import React from "react";
import "./hero.css";

// 1. Verify these paths exactly. If Assets is lowercase, change it here.
import img1 from "../../Assets/Hero/img (1).png";
import img2 from "../../Assets/Hero/img (2).png";
import img3 from "../../Assets/Hero/img (3).png";
import img4 from "../../Assets/Hero/img (4).png";
import img5 from "../../Assets/Hero/img (5).png";
import img6 from "../../Assets/Hero/img (6).webp";
import Button from "../Button/Button";

const Hero = () => {
  // Use a simple array structure
  const images = [
    { id: 1, src: img1, size: "tall" },
    { id: 2, src: img2, size: "small" },
    { id: 3, src: img3, size: "tall" },
    { id: 4, src: img4, size: "small" },
    { id: 5, src: img5, size: "tall" },
    { id: 6, src: img6, size: "small" },
  ];

  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="slider-wrapper">
          <div className="image-track">
            {/* First set */}
            {images.map((img) => (
              <div key={`set1-${img.id}`} className={`grid-item ${img.size}`}>
                <img src={img.src} alt="Insulation Project" />
              </div>
            ))}
            {/* Duplicate set for seamless loop */}
            {images.map((img) => (
              <div key={`set2-${img.id}`} className={`grid-item ${img.size}`}>
                <img src={img.src} alt="Insulation Project" />
              </div>
            ))}
          </div>
        </div>

        <div className="hero-content">
          <div className="content-left">
            <h1>
              Engineered <br /> <span>Thermal Solutions</span>
            </h1>
          </div>

          <div className="content-right">
            <h3>9+ Years of Expertise</h3>
            <p>
              Providing high-performance XLPE, nitrile rubber, boiler, and
              acoustic insulation materials trusted by industries.
            </p>
            <Button text="Get Quote" variant="primary" size="md" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
